import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import type { Permiso } from '@suminuta/shared';

// =====================================================
// QUERY KEYS
// =====================================================

export const permisosKeys = {
  all: ['permisos'] as const,
  lists: () => [...permisosKeys.all, 'list'] as const,
  list: () => [...permisosKeys.lists()] as const,
  activos: () => [...permisosKeys.all, 'activos'] as const,
  details: () => [...permisosKeys.all, 'detail'] as const,
  detail: (id: number) => [...permisosKeys.details(), id] as const,
};

// =====================================================
// QUERIES
// =====================================================

/**
 * Hook para obtener todos los permisos
 */
export const usePermisos = () => {
  return useQuery({
    queryKey: permisosKeys.list(),
    queryFn: async () => {
      const response = await api.get<{ success: boolean; data: Permiso[] }>(
        '/roles-permisos/permisos'
      );
      return response.data.data;
    },
  });
};

/**
 * Hook para obtener solo permisos activos
 */
export const usePermisosActivos = () => {
  return useQuery({
    queryKey: permisosKeys.activos(),
    queryFn: async () => {
      const response = await api.get<{ success: boolean; data: Permiso[] }>(
        '/roles-permisos/permisos/activos'
      );
      return response.data.data;
    },
  });
};

/**
 * Hook para obtener un permiso por ID
 */
export const usePermiso = (id: number) => {
  return useQuery({
    queryKey: permisosKeys.detail(id),
    queryFn: async () => {
      const response = await api.get<{ success: boolean; data: Permiso }>(
        `/roles-permisos/permisos/${id}`
      );
      return response.data.data;
    },
    enabled: !!id,
  });
};
